// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetPasswordRequested } from '../../store/auth.actions';

@Component({
  selector: 'coa-change-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {

  constructor(private store$: Store) {
  }

  reset(username: string): void {
    this.store$.dispatch(resetPasswordRequested({username}));
  }

}
